import { render, staticRenderFns } from "./supplier_goods_expand.vue?vue&type=template&id=15a77902&scoped=true&"
import script from "./supplier_goods_expand.vue?vue&type=script&lang=js&"
export * from "./supplier_goods_expand.vue?vue&type=script&lang=js&"
import style0 from "./supplier_goods_expand.vue?vue&type=style&index=0&id=15a77902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a77902",
  null
  
)

export default component.exports